<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    class="heroicon-identification heroicon heroicon-sm"
  >
    <path
      class="heroicon-identification-top heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M27 14H4a3 3 0 0 0-3 3v8h58v-8a3 3 0 0 0-3-3H33v3h1a2 2 0 1 1 0 4h-8a2 2 0 1 1 0-4h1v-3z"
    ></path>
    <rect
      class="heroicon-identification-clip heroicon-component-fill"
      width="6"
      height="10"
      x="27"
      y="8"
      fill="#FFFFFF"
    ></rect>
    <path
      class="heroicon-identification-card"
      fill="#FFFFFF"
      d="M1 25h58v24a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V25z"
    ></path>
    <path
      class="heroicon-identification-photo-background heroicon-component-accent heroicon-component-fill"
      fill="#7ACFC0"
      d="M19 28H5v20h1v-5c0-1.1.8-2.4 1.78-2.9l1.13-.56A3.98 3.98 0 0 1 8 37v-2a4 4 0 0 1 8 0v2c0 .97-.34 1.85-.91 2.54l1.13.57C17.2 40.6 18 41.89 18 43v5h1V28z"
    ></path>
    <path
      class="heroicon-identification-photo-user-top heroicon-component-fill"
      fill="#FFFFFF"
      d="M8.91 39.54l-1.13.57A3.55 3.55 0 0 0 6 43v5h12v-5c0-1.11-.8-2.4-1.78-2.9l-1.13-.56a3.99 3.99 0 0 1-6.18 0z"
    ></path>
    <rect
      class="heroicon-identification-photo-user-face heroicon-component-fill"
      width="8"
      height="10"
      x="8"
      y="31"
      fill="#FFFFFF"
      rx="4"
    ></rect>
    <path
      class="heroicon-outline"
      fill="#4A4A4A"
      fill-rule="nonzero"
      d="M26 7h8v6h22a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V17a4 4 0 0 1 4-4h22V7zm2 2v8h4V9h-4zm-2 6H4a2 2 0 0 0-2 2v7h56v-7a2 2 0 0 0-2-2H34v1a3 3 0 1 1 0 6h-8a3 3 0 1 1 0-6v-1zM2 49c0 1.1.9 2 2 2h52a2 2 0 0 0 2-2V25H2v24zm24-31a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2v1h-8v-1zm5-7a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM6 49H4V27h16v22H6zm13-21H5v20h1v-5c0-1.1.8-2.4 1.78-2.9l1.13-.56A3.98 3.98 0 0 1 8 37v-2a4 4 0 0 1 8 0v2c0 .97-.34 1.85-.91 2.54l1.13.57C17.2 40.6 18 41.89 18 43v5h1V28zm-2 20v-5c0-.73-.58-1.67-1.23-2l-1.47-.73a3.98 3.98 0 0 1-4.6 0L8.23 41A2.57 2.57 0 0 0 7 43v5h10zm-2-11v-2a3 3 0 1 0-6 0v2a3 3 0 1 0 6 0zm10-10h19v2H24v-2h1zm21 17h10v4H46v-4zm1 1v2h8v-2h-8zM25 34h21v1H24v-1h1zm0 2h23v1H24v-1h1zm0 2h13v1H24v-1h1zm0-8h25v2H24v-2h1zm-1 15h8v1h-8v-1zm0 2h7v1h-7v-1z"
    ></path>
  </svg>
</template>
